import { render } from "./CuentaShow.vue?vue&type=template&id=6d804d2e"
import script from "./CuentaShow.vue?vue&type=script&lang=js"
export * from "./CuentaShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__